export const codeKitchenSink = `
<template>
  <b-row>
    <b-col
      md="2"
      sm="4"
      class="my-1"
    >
      <b-form-group
        class="mb-0"
      >
        <label class="d-inline-block text-sm-left mr-50">Per page</label>
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          :options="pageOptions"
          class="w-50"
        />
      </b-form-group>
    </b-col>
    <b-col
      md="4"
      sm="8"
      class="my-1"
    >
      <b-form-group
        label="Sort"
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        label-for="sortBySelect"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-select
            id="sortBySelect"
            v-model="sortBy"
            :options="sortOptions"
            class="w-75"
          >
            <template v-slot:first>
              <option value="">
                -- none --
              </option>
            </template>
          </b-form-select>
          <b-form-select
            v-model="sortDesc"
            size="sm"
            :disabled="!sortBy"
            class="w-25"
          >
            <option :value="false">
              Asc
            </option>
            <option :value="true">
              Desc
            </option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col
      md="6"
      class="my-1"
    >
      <b-form-group
        label="Filter"
        label-cols-sm="3"
        label-align-sm="right"
        label-size="sm"
        label-for="filterInput"
        class="mb-0"
      >
        <b-input-group size="sm">
          <b-form-input
            id="filterInput"
            v-model="filter"
            type="search"
            placeholder="Type to Search"
          />
          <b-input-group-append>
            <b-button
              :disabled="!filter"
              @click="filter = ''"
            >
              Clear
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>

    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(avatar)="data">
          <b-avatar :src="data.value" />
        </template>

        <template #cell(status)="data">
          <b-badge :variant="status[1][data.value]">
            {{ status[0][data.value] }}
          </b-badge>
        </template>
      </b-table>
    </b-col>

    <b-col
      cols="12"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BRow, BCol, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BInputGroupAppend, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fields: [
        {
          key: 'id', label: 'Id',
        },
        {
          key: 'avatar', label: 'Avatar',
        },
        { key: 'full_name', label: 'Full Name', sortable: true },
        { key: 'post', label: 'Post', sortable: true },
        'email',
        'city',
        'start_date',
        'salary',
        'age',
        'experience',
        { key: 'status', label: 'Status', sortable: true },
      ],
      items: [
        {
          id: 1,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/10-small.png'),
          full_name: "Korrie O'Crevy",
          post: 'Nuclear Power Engineer',
          email: 'kocrevy0@thetimes.co.uk',
          city: 'Krasnosilka',
          start_date: '09/23/2016',
          salary: '$23896.35',
          age: '61',
          experience: '1 Year',
          status: 2,
        },
        {
          id: 2,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/1-small.png'),
          full_name: 'Bailie Coulman',
          post: 'VP Quality Control',
          email: 'bcoulman1@yolasite.com',
          city: 'Hinigaran',
          start_date: '05/20/2018',
          salary: '$13633.69',
          age: '63',
          experience: '3 Years',
          status: 2,
        },
        {
          id: 3,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/9-small.png'),
          full_name: 'Stella Ganderton',
          post: 'Operator',
          email: 'sganderton2@tuttocitta.it',
          city: 'Golcowa',
          start_date: '03/24/2018',
          salary: '$13076.28',
          age: '66',
          experience: '6 Years',
          status: 5,
        },
        {
          id: 4,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/3-small.png'),
          full_name: 'Dorolice Crossman',
          post: 'Cost Accountant',
          email: 'dcrossman3@google.co.jp',
          city: 'Paquera',
          start_date: '12/03/2017',
          salary: '$12336.17',
          age: '22',
          experience: '2 Years',
          status: 2,
        },
        {
          id: 5,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/4-small.png'),
          full_name: 'Harmonia Nisius',
          post: 'Senior Cost Accountant',
          email: 'hnisius4@gnu.org',
          city: 'Lucan',
          start_date: '08/25/2017',
          salary: '$10909.52',
          age: '33',
          experience: '3 Years',
          status: 2,
        },
        {
          id: 6,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/5-small.png'),
          full_name: 'Genevra Honeywood',
          post: 'Geologist',
          email: 'ghoneywood5@narod.ru',
          city: 'Maofan',
          start_date: '06/01/2017',
          salary: '$17803.80',
          age: '61',
          experience: '1 Year',
          status: 1,
        },
        {
          id: 7,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/7-small.png'),
          full_name: 'Eileen Diehn',
          post: 'Environmental Specialist',
          email: 'ediehn6@163.com',
          city: 'Lampuyang',
          start_date: '10/15/2017',
          salary: '$18991.67',
          age: '59',
          experience: '9 Years',
          status: 3,
        },
        {
          id: 8,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/9-small.png'),
          full_name: 'Richardo Aldren',
          post: 'Senior Sales Associate',
          email: 'raldren7@mtv.com',
          city: 'Skoghall',
          start_date: '11/05/2016',
          salary: '$19230.13',
          age: '55',
          experience: '5 Years',
          status: 3,
        },
        {
          id: 9,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/2-small.png'),
          full_name: 'Allyson Moakler',
          post: 'Safety Technician',
          email: 'amoakler8@shareasale.com',
          city: 'Mogilany',
          start_date: '12/29/2018',
          salary: '$11677.32',
          age: '39',
          experience: '9 Years',
          status: 5,
        },
        {
          id: 10,
          // eslint-disable-next-line global-require
          avatar: require('@/assets/images/avatars/6-small.png'),
          full_name: 'Merline Penhalewick',
          post: 'Junior Executive',
          email: 'mpenhalewick9@php.net',
          city: 'Kanuma',
          start_date: '04/19/2019',
          salary: '$15939.52',
          age: '23',
          experience: '3 Years',
          status: 2,
        },
      ],
      status: [{
        1: 'Current', 2: 'Professional', 3: 'Rejected', 4: 'Resigned', 5: 'Applied',
      },
      {
        1: 'light-primary', 2: 'light-success', 3: 'light-danger', 4: 'light-warning', 5: 'light-info',
      }],
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    info(item, index, button) {
      this.infoModal.title = \`Row index: \${index}\`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>
`

export const collections = [
{collection:'NPunks', collection_id:'near-punks.near'},
{collection:'Ape Near Club', collection_id:'ape-near-club-by-apenearclubnear'},
{collection:'Antisocial Ape Club', collection_id:'asac.near'},
{collection:'The Dons', collection_id:'nft.thedons.near'},
{collection:'ONE OF A KIND', collection_id:'one-of-a-kind-by-monztrenear'},
{collection:'Kokumo KongZ', collection_id:'kokumokongz.near'},
{collection:'The Munky Monkey', collection_id:'nft.themunkymonkey.near'},
{collection:'Kaizo Fighters', collection_id:'kaizofighters.tenk.near'},
{collection:'NEARNauts', collection_id:'nearnautnft.near'},
{collection:'Mara Gen 0', collection_id:'mara-gen-0-by-maranftnear'},
{collection:'Flipped Face', collection_id:'flipped-face-by-taiternnear'},
{collection:'Mara Gen 1', collection_id:'mara-smartcontract.near'},
{collection:'BOO Monster', collection_id:'boo-monster-by-omarbibznear'},
{collection:'Haven by AntiSocial Labs', collection_id:'mint.havendao.near'},
{collection:'Starry Night', collection_id:'starry-night-by-markoethnear'},
{collection:'The Undead Army', collection_id:'undead.secretskelliessociety.near'},
{collection:'Classy Kangaroos', collection_id:'classykangaroos1.near'},
{collection:'Secret Skellies Society', collection_id:'secretskelliessociety.near'},
{collection:'Metamon Pre-Launch Drop', collection_id:'metamon-pre-launch-drop-by-metamonnear'},
{collection:'NEAR Dragon Nation', collection_id:'dragonnation.near'},
{collection:'MR. BROWN', collection_id:'mrbrownproject.near'},
{collection:'El Café Cartel - Gen 1', collection_id:'cartelgen1.neartopia.near'},
{collection:'DEGEN Lizards', collection_id:'degenlizard.near'},
{collection:'NEARton', collection_id:'nearton_nft.near'},
{collection:'Freaky Elves by Spin', collection_id:'spin-nft-contract.near'},
{collection:'Grimms Army', collection_id:'grimms.secretskelliessociety.near'},
{collection:'NEARSkull_Punk', collection_id:'nearskullpunk-by-pandahaonear'},
{collection:'The Bullish Bulls', collection_id:'thebullishbulls.near'},
{collection:'Pixacotta Army', collection_id:'nft.pixacottaarmy.near'},
{collection:'Aurora Doves', collection_id:'auroradoves.near'},
{collection:'NEAR KONGZ', collection_id:'near-kongz-by-blissedkongnear'},
{collection:'NEAR Meerkat Kingdom', collection_id:'nmkmint.near'},
{collection:'Soul Bot', collection_id:'soul-bot-by-24ntrickernear'},
{collection:'Ugly Apes Society', collection_id:'uglyapes.neartopia.near'},
{collection:'NEAR Tiger Academy', collection_id:'tigeracademy.near'},
{collection:'NAGMI', collection_id:'nagmi.oldmantrader.near'},
{collection:'Near Tinker Union', collection_id:'tinkerunion_nft.enleap.near'},
{collection:'NEAR Misfits', collection_id:'misfits.tenk.near'},
{collection:'Near Street Wolves', collection_id:'nstreetwolves.near'},
{collection:'Project_NEARSkullz', collection_id:'projectnearskullz-by-pandahaonear'},
{collection:'Meta Foxonry', collection_id:'gen0.metafoxonry.near'},
{collection:'The Arrogant Youth Circle', collection_id:'tayc-nft.near'},
{collection:'Near Nomad', collection_id:'near-nomad-by-puunboynear'},
{collection:'AstroPups', collection_id:'astropup.near'},
{collection:'EngiNeart', collection_id:'engineart.near'},
{collection:'Grimms Army WL Token', collection_id:'grimmwl.secretskelliessociety.near'},
{collection:'Good Fortune Felines', collection_id:'nft.goodfortunefelines.near'},
{collection:'El Café Cartel - Gen 0', collection_id:'cartel.neartopia.near'},
{collection:'META ANTIHEROES', collection_id:'meta-antiheroes-by-sobgallerynear'},
{collection:'Pretty Punks', collection_id:'pretty-punks-by-agatheartsnear'},
{collection:'Holistic Pilgrims', collection_id:'623c2cd4294f600e58f46fa2.astrogenfunds.near'},
{collection:'Near Future: Primal', collection_id:'futurenft.near'},
{collection:'ZomLand', collection_id:'zomland-by-zomlandnear'},
{collection:'NEAR Skull Monkeys', collection_id:'near-skull-monkeys-by-herogranadanear'},
{collection:'Meta Space', collection_id:'themetaspace.near'},
{collection:'Halo Heads.', collection_id:'halo-heads-by-haloheadnear'},
{collection:'Pillars of Paras', collection_id:'pillars-of-paras-by-worldparasnear'},
{collection:'NearFox', collection_id:'nearfox-by-ludanear'},
{collection:'Dino Troop', collection_id:'dinotroop.neartopia.near'},
{collection:'Tokonami Revolution', collection_id:'tokodao.near'},
{collection:'Antisocial Ape Club: Fabled Apes', collection_id:'antisocial-ape-club-fabled-apes-by-asacnear'},
{collection:'Exxaverse Arena Tickets', collection_id:'tickets-exxaverse.near'},
{collection:'NEAR NFT DAO ', collection_id:'near-nft-dao-by-nearnftdaonear'},
{collection:'Billionaire Bulls Club', collection_id:'billionairebullsclub.near'},
{collection:'Alien Bear Crew', collection_id:'nft.alienbearcrew.near'},
{collection:'Near Buddies', collection_id:'near-buddies-by-nearbuddiesnear'},
{collection:'Metamon Reveal Day Drop', collection_id:'metamon-reveal-day-drop-by-metamonnear'},
{collection:'Box Head Monkey Club ', collection_id:'box-head-monkey-club-by-nuernear'},
{collection:'The Lion Pride', collection_id:'lionpride.neartopia.near'},
{collection:'Special CAGang Card', collection_id:'special-cagang-card-by-razcrypto22near'},
{collection:'Skullingham Estates', collection_id:'estates.secretskelliessociety.near'},
{collection:'Project Near_Chief Boss Bear', collection_id:'project-nearchief-boss-bear-by-yunayunanear'},
{collection:'The Nox', collection_id:'the-nox-by-thenoxnear'},
{collection:'Lazyman', collection_id:'lazyman-by-lazymannear'},
{collection:'RocketBois', collection_id:'rocketbois.neartopia.near'},
{collection:'SKELI DOGGO CLUB', collection_id:'skeli-doggo-club-by-burningshadowxdnear'},
{collection:'My Eyes ...', collection_id:'my-eyes-by-ontpnear'},
{collection:'Robotics', collection_id:'robotics-by-napjarunear'},
{collection:'Mr. BRRR NFT Vouchers', collection_id:'mr-brrr-nft-vouchers-by-burrownftnear'},
{collection:'The Wooks', collection_id:'the-wooks-by-nearwooksnear'},
{collection:'JELLY HOMIES', collection_id:'jelly-homies-by-darkalliesnear'},
{collection:'Genesis', collection_id:'genesis-by-parasnear'},
{collection:'Punky Monkey', collection_id:'punky-monkey-by-jaypnear'},
{collection:'NERD FOX CLUB', collection_id:'nerd-fox-club-by-chubblessnear'},
{collection:'Cool Dogs Club', collection_id:'cooldogsclub.near'},
{collection:'NEAR Gurls', collection_id:'neargurls.neartopia.near'},
{collection:'Near Panda Squad', collection_id:'near_panda_squad.near'},
{collection:'CRYPTO BUNNIES', collection_id:'crypto-bunnies-by-jeykartnear'},
{collection:'Vexed Apes Club', collection_id:'vexedapesclub.near'},
{collection:'MonkeGodz', collection_id:'monkegodz.tenk.near'},
{collection:'NEAR Extinct Heroes', collection_id:'extinctheroes.tenk.near'},
{collection:'SYKO NEAR BEARS SQUAD', collection_id:'syko-near-bears-squad-by-sykonearbearssquadnear'},
{collection:'Monkey Business | The 1897 Business', collection_id:'monkey-business-the-1897-business-by-wrecklessnear'},
{collection:'CLAPES', collection_id:'clapes-by-clapesnear'},
{collection:'NEARPunk', collection_id:'nearpunk-by-monztrenear'},
{collection:'Terraspaces', collection_id:'terraspaces.near'},
{collection:'The Architect’s Devices', collection_id:'the-architects-devices-by-mtvrsnear'},
{collection:'MonkeONear GEN0', collection_id:'monkeonear.neartopia.near'},
{collection:'WEIRD ALIEN', collection_id:'weird-alien-by-rbnznear'},
{collection:'The Lucky King ', collection_id:'the-lucky-king-by-pixeldogesynear'},
]